import { Pressable } from "@/components/ui/pressable";
import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { Image } from "@/components/ui/image";
import { HStack } from "@/components/ui/hstack";
import { Divider } from "@/components/ui/divider";
import { Center } from "@/components/ui/center";
import React from 'react';
import i18n from 'i18n-js';
import ChangeableText from '../basic/ChangeableText';
import MediaUpload from "../media/MediaUpload";
import { taskIcons } from '@/assets/images';
import { IconM } from '@/components/media/IconsV2';
import { useReactFlow } from 'reactflow';
import { B } from "@expo/html-elements";

export default function NodeDescription({ id, data, selected, disabled, nodeHighlighting }) {

    const onChangeTitle = (text) => {
        const newNodeData = { ...data, title: text }
        data.updateNode(id, newNodeData, false)
    }

    const onChangeDescription = (text) => {
        const newNodeData = { ...data, description: text }
        data.updateNode(id, newNodeData, false)
    }

    const { deleteElements } = useReactFlow();

    const borderRadius = selected || nodeHighlighting?.border ? 'rounded-tl-2 rounded-tr-2' : 'rounded-tl-5 rounded-tr-5'

    return (
        <VStack>
            <HStack className={` ${borderRadius} relative ${data.nodeType === 'workflowStartNode' ? "bg-primary-900" : "bg-primary-50"} py-2 items-center `}>
                {taskIcons[data.nodeType] && <Center className="ml-4 bg-[#FFFFFF] rounded-md border border-[#BEBEBE] w-[40px] h-[40px]">
                    <Image size='xs' source={taskIcons[data.nodeType]} alt={i18n.t('global.missingImage')} className="flex-1" />
                </Center>}
                {data.nodeType !== 'workflowStartNode' && selected && !disabled && <HStack className="absolute -top-[48px] right-0">
                    <View className="bg-primary-50 border border-primary-900 rounded-[4px] p-1 mr-[2px]">
                        <IconM className='text-primary-900' size={30} name='content-copy' />
                        <Pressable
                            onPress={() => {
                                console.log('COPY', id, data)
                                data.copyNode(data.nodeType, data, id)
                            }}
                            className="absolute w-8 h-8" />
                    </View>
                    <View className="bg-primary-50 border border-primary-900 rounded-[4px] p-1 ml-[2px]">
                        <IconM className='text-primary-900' size={30} name='delete' />
                        <Pressable
                            onPress={() => {
                                console.log('DELETE', id, data)
                                deleteElements({ nodes: [{ id: id }] })
                            }}
                            className="absolute w-8 h-8" />
                    </View>
                </HStack>}
                <ChangeableText
                    text={data.title}
                    placeholder={i18n.t(data.nodeType == 'workflowStartNode' ? 'studio.itemInput.title' : 'itemInput.title')}
                    updateText={onChangeTitle}
                    fontSize='text-2xl'
                    fontWeight='font-bold'
                    colorInverted={data.nodeType === 'workflowStartNode'}
                    disabled={disabled}
                />
            </HStack>
            <Divider />
            <HStack>
                <ChangeableText
                    text={data.description}
                    placeholder={i18n.t(data.nodeType == 'workflowStartNode' ? 'studio.itemInput.text' : 'itemInput.text')}
                    fontSize='text-xl'
                    updateText={onChangeDescription}
                    disabled={disabled}
                />
            </HStack>
            <Divider />
            <MediaUpload nodeId={id} data={data} disabled={disabled} />
        </VStack>
    );
}
